import React from "react";
import { Box, TextField, MenuItem, Typography } from "@mui/material";

const ElectricPlantForm = ({
  localNotes,
  handleLocalNotesChange,
  questions,
  schedule_checklists,
}) => {
  // Lista completa de preguntas con sus tipos de entrada

  const mapQuestionsWithOptions = (questions) => {
    // Define las opciones para las preguntas de tipo select
    const selectOptions = {
      correas: ["bueno", "malo"],
      radiador: ["bueno", "malo"],
      intercambiador: ["bueno", "malo"],
      "limpieza cuarto": ["bueno", "malo"],
      "estado accesorios cargador de baterias": ["bueno", "malo"],
      "estado accesorios precalentador": ["bueno", "malo"],
      "estado accesorios otros": ["bueno", "malo"],
      tranferencia: ["monocuenta", "manual", "automatica", "multicuneta"],
      "sistema de escape fugas": ["si", "no"],
      "sistemas de proteccion presion": ["bien", "mal"],
      "sistemas de proteccion temperatura": ["bien", "mal"],
      "sistemas de proteccion velocidad": ["bien", "mal"],
      "sistemas de proteccion refrigerante": ["bien", "mal"],
      "sistemas de proteccion arranque": ["bien", "mal"],
      "estado sistema de combustible fugas": ["si", "no"],
    };

    // Agrega las opciones a las preguntas de tipo select
    return questions.map((question) => {
      if (
        question.input_type === "select" &&
        selectOptions[question.question]
      ) {
        return {
          ...question,
          options: selectOptions[question.question],
        };
      }
      return question; // Si no es select o no tiene opciones definidas, regresa el objeto original
    });
  };

  const renderInput = (question) => {
    const checklist = schedule_checklists?.find(
      (cl) => cl.checklist_question_id === question.id
    );
    switch (question.input_type) {
      case "textarea":
        return (
          <TextField
            fullWidth
            multiline
            rows={3}
            label={question.question}
            value={localNotes[question.id] ?? checklist?.notes ?? ""}
            onChange={(e) =>
              handleLocalNotesChange(question.id, e.target.value)
            }
          />
        );
      case "select":
        return (
          <div className="form-group">
            <label>{question.question}</label>
            <select
              value={localNotes[question.id] ?? checklist?.notes ?? ""}
              onChange={(e) =>
                handleLocalNotesChange(question.id, e.target.value)
              }
            >
              <option value="-">-</option>
              {(question.options || []).map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        );
      default:
        return (
          <TextField
            fullWidth
            label={question.question}
            value={localNotes[question.id] ?? checklist?.notes ?? ""}
            onChange={(e) =>
              handleLocalNotesChange(question.id, e.target.value)
            }
          />
        );
    }
  };

  return (
    <Box>
      <Typography variant="h6">Formulario Planta Eléctrica</Typography>
      {mapQuestionsWithOptions(questions).map((question) => (
        <Box key={question.id} sx={{ mb: 2 }}>
          {renderInput(question)}
        </Box>
      ))}
    </Box>
  );
};

export default ElectricPlantForm;
